<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-2">
      <span style="font-size: 14px">{{ title }}</span>
      <b-button
        size="sm"
        variant="primary"
        class="text-white mt-2"
        style="width: 31px"
        @click="addRow"
      >
        <i class="fa fa-plus" />
      </b-button>
    </div>
    <div class="table-container" style="overflow-x: inherit">
      <b-table
        striped
        hover
        :items="tableItems"
        :fields="tableFields"
        thead-class="bg-extra-light-gray"
        class="mb-0"
      >
        <template #table-colgroup="scope">
          <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="
              field.key != 'actions' ? 'minWidth: 100px; max-width:100px;' : ''
            "
          />
        </template>
        <template #cell(actions)="row">
          <i
            @click="removeRow(row.index)"
            class="fa fa-trash text-danger hover-pointer"
            style="margin-top: 6px"
          />
        </template>
        <template #cell()="data">
          <b-input-group v-if="data.field.type == 'text_autopopulate'">
            <b-form-input
              :style="`width: ${getWidth(data)}`"
              size="sm"
              :value="data.value"
              @input="
                newValue =>
                  updateCellValue(data.index, data.field.key, newValue)
              "
            ></b-form-input>
            <b-input-group-append>
              <b-dropdown
                ref="autocompleteDropdown"
                size="sm"
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
                boundary="window"
                @show="textAutopopulateSearch = ''"
              >
                <template #button-content>
                  <i class="fa fa-search" aria-hidden="true"></i
                  ><span class="sr-only">Search</span>
                </template>
                <b-dropdown-form style="width: 250px;" class="m-2">
                  <div class="table-text-autopopulate-container">
                    <b-form-input
                      placeholder="Search..."
                      size="sm"
                      class="mb-2"
                      v-model="textAutopopulateSearch"
                    />
                    <div class="table-text-autopopulate">
                      <b-table
                        striped
                        hover
                        :items="filterAutopopulateOptions(data.field.options)"
                        :fields="['code', 'description']"
                        style="font-size:13px;"
                        @row-clicked="
                          item => onRowClicked(data.index, data.field.key, item)
                        "
                      >
                        <template #table-colgroup="scope">
                          <col
                            v-for="field in scope.fields"
                            :key="field.key"
                            :style="{
                              width: field.key === 'code' ? '27%' : 'auto'
                            }"
                          />
                        </template>
                        <template #cell()="row">
                          <div
                            @click="
                              updateCellValue(
                                data.index,
                                data.field.key,
                                row.item.code
                              )
                            "
                            class="tableDescription"
                          >
                            {{ row.value }}
                          </div>
                        </template>
                      </b-table>
                    </div>
                  </div>
                </b-dropdown-form>
              </b-dropdown>
            </b-input-group-append>
          </b-input-group>

          <b-form-input
            :style="`width: ${getWidth(data)}`"
            v-if="data.field.type == 'text'"
            size="sm"
            :value="data.value"
            @input="
              newValue => updateCellValue(data.index, data.field.key, newValue)
            "
          ></b-form-input>
          <date-picker
            style="width: 150px"
            v-if="data.field.type == 'date'"
            size="sm"
            :value="data.value"
            @input="
              newValue => updateCellValue(data.index, data.field.key, newValue)
            "
          ></date-picker>
          <b-form-input
            v-if="data.field.type == 'number'"
            type="number"
            min="0"
            size="sm"
            :value="data.value"
            @input="
              newValue => updateCellValue(data.index, data.field.key, newValue)
            "
          ></b-form-input>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import DatePicker from "./DatePicker";
export default {
  name: "TableCrud",
  components: { DatePicker },
  props: ["title", "fields", "value"],
  data() {
    return {
      textAutopopulateSearch: ""
    };
  },
  methods: {
    addRow() {
      const newValue = [...this.value];
      newValue.push({});
      this.$emit("input", newValue);
    },
    removeRow(rowIndex) {
      const newValue = [...this.value];
      newValue.splice(rowIndex, 1);
      this.$emit("input", newValue);
    },
    updateCellValue(rowIndex, property, propertyNewValue) {
      if (this.$refs.autocompleteDropdown) {
        this.$refs.autocompleteDropdown.hide();
      }
      const newValue = [...this.value];
      newValue[rowIndex][property] = propertyNewValue;
      this.$emit("input", newValue);
    },
    getWidth(data) {
      if (
        data.field.key === "mod1" ||
        data.field.key === "mod2" ||
        data.field.key === "mod3" ||
        data.field.key === "mod4"
      ) {
        return "60px";
      }
    },
    filterAutopopulateOptions(options) {
      let result = options;
      if (this.textAutopopulateSearch) {
        result = options.filter(
          option =>
            option.code
              .toLowerCase()
              .includes(this.textAutopopulateSearch.toLowerCase()) ||
            option.description
              .toLowerCase()
              .includes(this.textAutopopulateSearch.toLowerCase())
        );
      }
      return result;
    },
    onRowClicked(data, key, item) {
      this.updateCellValue(data, key, item.code);
    }
  },
  computed: {
    tableFields() {
      return [
        ...this.fields.map(field => ({
          key: field.field,
          label: field.text,
          type: field.type,
          options: field.options
        })),
        {
          key: "actions",
          label: ""
        }
      ];
    },
    tableItems() {
      return this.value;
    }
  }
};
</script>

<style scoped>
.table-container >>> .table th {
  border-top: none;
  white-space: nowrap;
  max-width: 100px;
  overflow-x: hidden;
  font-size: 13px;
}
.table-container >>> .table td {
  padding: 5px;
}

.tableDescription {
  cursor: pointer;
}

.table-text-autopopulate {
  overflow-y: auto !important;
  max-height: 200px !important;
}
.table-text-autopopulate-container >>> .table th,
.table-text-autopopulate-container >>> .table td {
  padding: 5px 12px !important;
}
.table-text-autopopulate-container >>> .table tr {
  cursor: pointer;
}
</style>
